import React from 'react';

type ToolboxNodeType = 'themeNode';

type ToolboxItemProps = {
  label: string;
  description: string;
  type: ToolboxNodeType;
};

const ToolboxItem: React.FC<ToolboxItemProps> = ({ label, description, type }) => {
  const handleDragStart = (event: React.DragEvent<HTMLDivElement>) => {
    event.dataTransfer.setData('application/reactflow', type);
    event.dataTransfer.effectAllowed = 'move';
  };

  return (
    <div
      draggable
      onDragStart={handleDragStart}
      className="cursor-grab rounded-xl border border-blue-200 bg-white p-4 shadow-sm transition hover:border-blue-300 hover:shadow-md active:cursor-grabbing"
    >
      <p className="text-sm font-semibold text-blue-900">{label}</p>
      <p className="mt-1 text-xs text-gray-600">{description}</p>
    </div>
  );
};

const ThesisToolbox: React.FC = () => {
  return (
    <aside className="w-full max-w-xs rounded-2xl border border-gray-200 bg-white p-4 shadow-sm">
      <h2 className="text-base font-bold text-gray-900">Painel de Ferramentas</h2>
      <p className="mt-1 text-xs text-gray-500">Arraste os itens para o mapa mental.</p>

      <div className="mt-4 space-y-3">
        <ToolboxItem
          type="themeNode"
          label="Novo Tema"
          description="Nó gatilho de notícias com termos de busca."
        />
      </div>
    </aside>
  );
};

export default ThesisToolbox;
